import { IFeatureAccountQuery, useFeatureAccountQuery } from 'generated/sanity-graphql';

interface IFeatureAccountValue {
  featureAccountLoading: boolean;
  featureAccountData: IFeatureAccountQuery['FeatureAccount'];
}

export const FEATURE_ACCOUNT_SINGLETON_ID = 'feature-account-singleton';

export const useFeatureAccount = (): IFeatureAccountValue => {
  const { data, loading } = useFeatureAccountQuery({
    variables: { featureAccountId: FEATURE_ACCOUNT_SINGLETON_ID },
  });

  const featureAccountLoading = loading;
  const featureAccountData = data?.FeatureAccount ?? null;

  return {
    featureAccountLoading,
    featureAccountData,
  };
};
